import { createSlice } from "@reduxjs/toolkit";
import { getListZnsEventBranchMap } from "../../api/znsEvent/znsEventBranchMap";

// giá trị khởi tạo của state
const initialState = {
  listZnsEventBranchMaps: [],
  isLoadZnsEventBranchMap: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API  
};

const znsEventBranchMapSlice = createSlice({
  name: "znsEventBranchMap", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListZnsEventBranchMap.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadZnsEventBranchMap = true;
        state.error = null;
      })
      .addCase(getListZnsEventBranchMap.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadZnsEventBranchMap = false;
        state.listZnsEventBranchMaps = action.payload.data || [];

        state.isLoadZnsEventBranchMap = false;
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListZnsEventBranchMap.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadZnsEventBranchMap = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } = znsEventBranchMapSlice.actions;
export default znsEventBranchMapSlice.reducer;
